import React from 'react'
import './Header.css'

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <h1 className="logo-text">
              <span className="logo-primary">Lazy Load</span>
              <span className="logo-secondary">Studios</span>
            </h1>
          </div>
          <nav className="nav">
            <a href="#home" className="nav-link">Home</a>
            <a href="#projects" className="nav-link">Projects</a>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header